import React, { useState } from 'react';
import { Star, Zap } from 'lucide-react';
import { useSubscription } from '@/context/SubscriptionContext';
import { PlanUpgradeModal } from '@/components/PlanUpgradeModal';

/**
 * Badge de estado del plan actual
 * - Lee el plan efectivo de useSubscription()
 * - Muestra icono + nombre del plan
 * - Al pulsar, abre PlanUpgradeModal
 */

const PLAN_STYLES = {
  free: {
    label: 'Free',
    icon: null,
    classes: 'border border-border text-muted-foreground bg-card hover:bg-muted',
  },
  premium_personal: {
    label: 'Personal',
    icon: <Star className="h-3 w-3 text-yellow-500" />,
    classes: 'border border-yellow-400 text-yellow-700 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 hover:bg-yellow-100 dark:hover:bg-yellow-900/40',
  },
  premium_pro: {
    label: 'Pro',
    icon: <Zap className="h-3 w-3 text-blue-500" />,
    classes: 'border border-blue-400 text-blue-700 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/40',
  },
};

export function PlanStatusBadge() {
  const { plan, isPlanReady } = useSubscription();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // No renderizar hasta que el plan esté resuelto
  if (!isPlanReady) return null;

  const style = PLAN_STYLES[plan] ?? PLAN_STYLES.free;

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={`flex items-center gap-0.5 px-1.5 py-px rounded-full text-xs font-medium transition-colors ${style.classes}`}
        title="Ver planes"
        aria-label={`Plan: ${style.label}. Toca para ver opciones`}
      >
        {style.icon}
        <span>{style.label}</span>
      </button>

      <PlanUpgradeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
